import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-chat_csat-submit';
/**
 * Fire CSAT result when chat is ended
 */
export function trackHelpCenterChatCsatSubmit(CSATResult, AgentDisplayName2, retailerOrBrandToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: { CSATResult, AgentDisplayName2, retailerOrBrandToken3 },
    });
}
